export const displayPlural = ({ count, word }: { count: number; word: string }) =>
  `${count} ${word}${count > 1 ? "s" : ""}`;
